import { useState } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerSearch = props => {
  const [recentSearchClick, setRecentSearchClick] = useState(false)
  const [commonSearchClick, setCommonSearchClick] = useState(false)

  const recentCommonSearchesHandler = event => {
    if (
      containsValidTargetClass(
        ["luna-nav-search__recent-and-common-searches--common"],
        event?.target?.parentElement?.classList
      )
    ) {
      setRecentSearchClick(false)
      setCommonSearchClick(true)
    }
    if (
      containsValidTargetClass(
        ["luna-nav-search__recent-and-common-searches--recent"],
        event?.target?.parentElement?.classList
      )
    ) {
      setCommonSearchClick(false)
      setRecentSearchClick(true)
    }
  }

  const datalayerSearchResultHandler = event => {
    if (
      containsValidTargetClass(
        ["nav-search__hit--link"],
        event?.target?.classList
      )
    ) {
      window.dataLayer = window.dataLayer || []
      let searchFilterText = ""
      document
        .querySelectorAll(".luna-nav-search__filter-active")
        .forEach(filter => {
          searchFilterText = searchFilterText + " " + filter.innerText
        })

      window.dataLayer.push({
        event: "search",
        search_term: document.querySelector(".nav-search__search-box--input")
          .value,
        number_of_results: document
          .querySelector(".nav-search__stats__text")
          ?.innerText?.split(" ")
          .pop()
          .replace(/\(|\)/g, ""),
        search_url_clicked: event.target.href,
        recent_search_clicked: recentSearchClick,
        common_search_clicked: commonSearchClick,
        search_filter: searchFilterText,
      })
    }
  }
  // add handler if relevant listener elem exists
  let queryCommon,
    querySearch = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    queryCommon =
      document?.querySelectorAll(
        ".luna-nav-search__recent-and-common-searches--common, luna-nav-search__recent-and-common-searches--recent"
      ).length > 0
    querySearch =
      document?.querySelectorAll(".nav-search__search-box--input").length > 0
  }
  useClickListener(recentCommonSearchesHandler, queryCommon)
  useClickListener(datalayerSearchResultHandler, querySearch)
}

export default DatalayerSearch
